var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "archival-disabled-messaging" }, [
    _c(
      "div",
      { staticClass: "message-group" },
      [
        _vm._l(_vm.archivalDisabledMessage, function(message, index) {
          return _c("p", { key: index }, [
            _vm._v("\n      " + _vm._s(message) + "\n    ")
          ])
        }),
        _vm._v(" "),
        _vm.historyArchivalLinks
          ? _c(
              "div",
              _vm._l(_vm.historyArchivalLinks, function(link, index) {
                return _c("div", { key: index }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: link.href,
                        rel: "noopener noreferrer",
                        target: "_blank"
                      }
                    },
                    [_vm._v("\n          " + _vm._s(link.label) + "\n        ")]
                  )
                ])
              }),
              0
            )
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    !_vm.isHistoryArchivalEnabled
      ? _c("div", { staticClass: "message-group" }, [
          _c("p", [
            _vm._v(
              "\n      " + _vm._s(_vm.historyArchivalDisabledMessage) + "\n    "
            )
          ]),
          _vm._v(" "),
          _vm.historyArchivalEnableCommand
            ? _c("div", [
                _c("pre", [_vm._v(_vm._s(_vm.historyArchivalEnableCommand))])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isVisibilityArchivalEnabled
      ? _c("div", { staticClass: "message-group" }, [
          _c("p", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.visibilityArchivalDisabledMessage) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _vm.visibilityArchivalEnableCommand
            ? _c("div", [
                _c("pre", [_vm._v(_vm._s(_vm.visibilityArchivalEnableCommand))])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d76f08a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d76f08a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/domain/workflow-archival/components/archival-disabled-messaging/index.vue
// module id = 1759
// module chunks = 0